import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageNavBreadcrumbs from "src/features/breadcrumbs/PageNavBreadcrumbs";
import AudioPlayer from "src/features/conversation/audioPlayer/AudioPlayer";
import BaseHeader from "src/pages/layout/Header";
import "./Header.scss";
const Header = () => {
    return (_jsxs(BaseHeader, { className: 'conversation-details-header', children: [_jsx(PageNavBreadcrumbs, {}), _jsx(AudioPlayer, {})] }));
};
export default Header;
